// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-services-js": () => import("./../../../src/components/services.js" /* webpackChunkName: "component---src-components-services-js" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-stores-jsx": () => import("./../../../src/pages/stores.jsx" /* webpackChunkName: "component---src-pages-stores-jsx" */)
}

